var map = {
	"./da/americanFootball.json": 33505,
	"./da/authentication.json": 40746,
	"./da/common.json": 2219,
	"./da/competitions.json": 98750,
	"./da/contests.json": 52439,
	"./da/cycling.json": 66479,
	"./da/golf.json": 23770,
	"./da/groups.json": 53302,
	"./da/handball.json": 41478,
	"./da/hockey.json": 99903,
	"./da/messageboard.json": 66551,
	"./da/motorsport.json": 96635,
	"./da/no_filename.json": 52551,
	"./da/notifications.json": 28842,
	"./da/soccer.json": 74265,
	"./da/stock.json": 79020,
	"./da/time.json": 40467,
	"./en/americanFootball.json": 30241,
	"./en/authentication.json": 15722,
	"./en/common.json": 10859,
	"./en/competitions.json": 79326,
	"./en/contests.json": 56631,
	"./en/cycling.json": 9775,
	"./en/golf.json": 17466,
	"./en/groups.json": 10678,
	"./en/handball.json": 89030,
	"./en/hockey.json": 19903,
	"./en/messageboard.json": 86903,
	"./en/motorsport.json": 91803,
	"./en/no_filename.json": 77255,
	"./en/notifications.json": 57610,
	"./en/soccer.json": 73209,
	"./en/stock.json": 65228,
	"./en/time.json": 29907,
	"./sv/americanFootball.json": 61447,
	"./sv/authentication.json": 10836,
	"./sv/common.json": 78941,
	"./sv/competitions.json": 32300,
	"./sv/contests.json": 12141,
	"./sv/cycling.json": 72261,
	"./sv/golf.json": 79656,
	"./sv/groups.json": 76656,
	"./sv/handball.json": 44328,
	"./sv/hockey.json": 47061,
	"./sv/messageboard.json": 80537,
	"./sv/motorsport.json": 64645,
	"./sv/no_filename.json": 9353,
	"./sv/notifications.json": 31780,
	"./sv/soccer.json": 41559,
	"./sv/stock.json": 97450,
	"./sv/time.json": 55693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96068;